import { CreateModuleDTO } from '@/jbi-shared/dto/jtms.dtos';
import {
  ModuleQueryParams,
  PaginatedModules,
  UpdateModuleApiDTO
} from '@/store/modules/jtms/module/module.types';
import { axios } from './axios';
export const moduleApi = {
  getModules() {
    return axios.get('/modules/all');
  },
  getPaginatedModules(params: ModuleQueryParams) {
    return axios.get<PaginatedModules>('/modules', {
      params: {
        ...params
      }
    });
  },

  createModule(payload: CreateModuleDTO) {
    return axios.post('/modules', payload);
  },

  updateModule(payload: UpdateModuleApiDTO) {
    const { moduleId, ...updatePayload } = payload;
    return axios.patch(`/modules/${moduleId}`, updatePayload);
  }
};
